import { sitePhrasing } from "../../../../Language/languageHandler";
import { AddressInputFieldGroup } from "../../../FormFields/AddressFieldGroup/AddressInputFieldGroup";
import {
  ArrayEntryFieldType,
  ArrayFieldInput,
} from "../../../FormFields/ArrayField/ArrayFieldInput";
import CheckboxInputField from "../../../FormFields/CheckboxInputField/CheckboxInputField";
import RadioInputField from "../../../FormFields/RadioInputField/RadioInputField";
import SelectFieldInput from "../../../FormFields/SelectInputField/SelectInputField";
import TextAreaInputField from "../../../FormFields/TextAreaInputField/TextAreaInputField";
import TextInputField from "../../../FormFields/TextInputField/TextInputField";
import { ContactInfoFields } from "../ContactInfoFields";
import { ADDRESS_FIELD_NAMES, electronicSignatureSublabelGeneral, iAgreeText, laborLawPosterAgreementText, mayBeContactedAgreementText, stateTransactionAcknowledgmentText, yesOrNoValues } from "../PurchaseConstants";
import { AnnualReferenceNumberInstructions, TermsAndConditionAcceptText } from "../SharedPurchaseFieldComponents";
import { MississippiAnnualReportTerms } from "./StateSpecificAnnualTerms";

export default function MississippiAnnualReportFields(props: {
  values: any;
  errors: any;
  touched: any;
  setFieldValue: (field: string, value: any) => void;
  selectedProducts: any;
}) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    selectedProducts,
  } = props;

  return (
    <>
      <ContactInfoFields
        values={values}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
      />

      <TextInputField
        mask={sitePhrasing.referenceMask}
        fieldName={"referenceNumber"}
        fieldLabel={"Reference Number"}
        fieldSubLabel={undefined}
        customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Reference Number"}
        maskGuide={sitePhrasing.referenceMaskGuide}
      />

      <TextInputField
        fieldName={"businessName"}
        fieldLabel={"Complete Business Name"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Complete Business Name"}
      />

      <div className="field-container">
        <label htmlFor="annualReport.informationChange.principalAddress.newAddress">
          Company Principal Address*
        </label>
        <br />
        <div className="error-sub-label bold-sub-label">
          <div className="sub-label">
            No PO Boxes
          </div>
        </div>
      </div>

      <AddressInputFieldGroup
        fieldName={"annualReport.informationChange.principalAddress.newAddress"}
        errors={errors}
        touched={touched}
      />

      <br />

      {values.annualReport.typeOfEntity !== "corporation" && (
        <RadioInputField
          fieldName={"annualReport.useSSN"}
          fieldLabel={"When it comes to tax purposes, which does your business use?"}
          errors={errors}
          required={true}
          touched={touched}
          customClass="block-radio"
          options={[
            {
              value: "EIN",
              label: "EIN",
            },
            // {
            //   value: "FEI",
            //   label: "FEI",
            // },
            {
              value: "SSN",
              label: "SSN",
            }
          ]}
        />
      )}

      {values.annualReport.useSSN && values.annualReport.useSSN !== 'SSN' && (
        <>
          <TextInputField
            mask={[/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
            fieldName={"annualReport.feiEin"}
            fieldLabel={values.annualReport.typeOfEntity === "corporation" ? "When it comes to tax purposes, what is the EIN associated with this business?" : "EIN Number"}
            // fieldLabel={"EIN Number"}
            // fieldLabel={"FEI/EIN Number"}
            errors={errors}
            touched={touched}
            required={true}
            placeholder={"FEI/EIN Number"}
          />
          <div className="field-note">
            If you have not yet obtained your EIN Federal Tax ID, you may do so now by{" "}<a href="/" target="_blank" className="link-text"> clicking here</a>.
          </div>
        </>
      )}


      <TextInputField
        fieldName={"annualReport.natureOfBusiness"}
        fieldLabel={"Nature of Business"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Nature of Business"}
      />



      {values.annualReport.typeOfEntity === "nonProfit" && (
        <>
          <RadioInputField
            fieldName={"annualReport.nonProfitMembers"}
            fieldLabel={"Does this Non-Profit have members?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />

          <RadioInputField
            fieldName={"annualReport.isNonProfit501c3"}
            fieldLabel={"Is this Non-Profit Corporation approved by the IRS under section 501(c)(3)?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />

          {values.annualReport.isNonProfit501c3 === "yes" && (
            <TextAreaInputField
              fieldName={"annualReport.purposeOfNonProfit"}
              fieldLabel={"State the Non-Profit purpose listed on the 501(c)(3) application"}
              errors={errors}
              fieldType={"textarea"}
              touched={touched}
              required={true}
              placeholder={""}
              rows={4}
            />
          )}

          <RadioInputField
            fieldName={"annualReport.nonProfitSolicitDonations"}
            fieldLabel={"Does this Non-Profit Corporation solicit donations?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />

          <RadioInputField
            fieldName={"annualReport.nonProfitPublicFunds"}
            fieldLabel={"Does this Non-Profit Corporation receive public funds from the State of Mississippi or any local government authority located within the State of Mississippi?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
        </>
      )}

      <h3>Do you need to change any of the following information?</h3>

      <RadioInputField
        fieldName={"annualReport.informationChange.NAICS.changeCodes"}
        fieldLabel={"Nature of Business NAICS codes?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />

      {values.annualReport.informationChange.NAICS.changeCodes === "yes" && (
        <div className="naics-section">
          (Enter up to 3 NAICS codes)
          <div className="naics-split-box">
            <TextInputField
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              // mask={[/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
              fieldName={"annualReport.informationChange.NAICS.code1"}
              fieldLabel={"1."}
              errors={errors}
              touched={touched}
              required={true}
              customClass="inline-input border-input"
              placeholder={"NAICS Code"}
            />
            <TextInputField
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              fieldName={"annualReport.informationChange.NAICS.code2"}
              fieldLabel={"2."}
              errors={errors}
              touched={touched}
              required={false}
              customClass="inline-input border-input"
              placeholder={"NAICS Code"}
            />
            <TextInputField
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              fieldName={"annualReport.informationChange.NAICS.code3"}
              fieldLabel={"3."}
              errors={errors}
              touched={touched}
              required={false}
              customClass="inline-input border-input"
              placeholder={"NAICS Code"}
            />
          </div>
          <a href="https://www.naics.com/search/" target="_blank" rel="noreferrer" className="link-text">Click Here to search for NAICS codes</a>
        </div>
      )}

      <CheckboxInputField
        fieldName={"annualReport.hasWrittenOperatingAgreement"}
        fieldLabel={"This LLC has a written operating agreement"}
        errors={errors}
        touched={touched}
      />

      <RadioInputField
        fieldName={"annualReport.informationChange.changeOfficers"}
        fieldLabel={"Officers and Directors?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />

      {values.annualReport.informationChange.changeOfficers === "yes" && (
        <>
          <RadioInputField
            fieldName={"annualReport.informationChange.authorizedPerson.addingAgents"}
            fieldLabel={`Addings New Officers/Directors?`}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.authorizedPerson
            .addingAgents === "yes" && (
              <ArrayFieldInput
                fieldName={"annualReport.informationChange.authorizedPerson.addedAgents"}
                values={values.annualReport.informationChange.authorizedPerson.addedAgents}
                blankEntryFn={blankRegisteredAgentFn}
                fields={registeredAgentFields}
                touched={touched}
                errors={errors}
                removeText={"- Click to remove entry"}
                addText={"+ Click to add an entry"}
              />
            )}

          <RadioInputField
            fieldName={"annualReport.informationChange.authorizedPerson.removingAgents"}
            fieldLabel={`Removing Officers/Directors?`}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.authorizedPerson.removingAgents === "yes" && (
            <ArrayFieldInput
              fieldName={"annualReport.informationChange.authorizedPerson.removedAgents"}
              values={values.annualReport.informationChange.authorizedPerson.removedAgents}
              blankEntryFn={blankRegisteredAgentFn}
              fields={registeredAgentFields}
              touched={touched}
              errors={errors}
              removeText={"- Click to remove entry"}
              addText={"+ Click to add an entry"}
            />
          )}
        </>
      )}


      <div className="terms-and-conditions-container">
        <MississippiAnnualReportTerms />
        <br /><br />
        {iAgreeText}
        <br /><br />
        {selectedProducts["laborLawPoster"] && (
          <>
            {laborLawPosterAgreementText}
            <br /><br />
          </>
        )}
        {stateTransactionAcknowledgmentText}
        <br /><br />
        <TermsAndConditionAcceptText />
      </div>

      <CheckboxInputField
        fieldName={'termAndConditionAgree'}
        fieldLabel={`I've read and accept the terms and conditions.`}
        touched={touched}
        errors={errors}
        onChange={(e: any) => {
          const checkedVal = e.target.checked ? true : false;
          setFieldValue('annualReport.annualAgree', checkedVal)
          setFieldValue('annualReport.iAmAuthorized', checkedVal)
          setFieldValue('iAgree', checkedVal)
          setTimeout(() => {
            setFieldValue('termAndConditionAgree', checkedVal)
          }, 0)

        }}
      />

      <TextInputField
        fieldName={"annualReport.electronicSignature"}
        fieldLabel={"Name of Individual Signing - Electronic Signature"}
        fieldSubLabel={electronicSignatureSublabelGeneral}
        fieldSubLabelCustomClass={'red-text'}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Electronic Signature"}
        customClass={"signature-font"}
      />

      <SelectFieldInput
        fieldName={"annualReport.title"}
        fieldLabel={"Title"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"- Select Title -"}
        options={signatureTitleValues}
      />

      <AddressInputFieldGroup
        fieldName={"annualReport.signerAddress"}
        errors={errors}
        touched={touched}
      />
    </>
  );
}

export const blankRegisteredAgentFn = () => ({
  name: "",
  title: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
});

const titleValues = [
  {
    label: "Manager",
    value: "Manager",
  },
  {
    label: "Member",
    value: "Member",
  },
  {
    label: "President",
    value: "President",
  },
  {
    label: "Other",
    value: "Other",
  },
  {
    label: "Vice President",
    value: "Vice President",
  },
  {
    label: "Secretary",
    value: "Secretary",
  },
  {
    label: "Treasurer",
    value: "Treasurer",
  },
  {
    label: "Attorney In Fact",
    value: "Attorney In Fact",
  },
];

export const registeredAgentFields: ArrayEntryFieldType[] = [
  {
    fieldType: "text",
    fieldName: "name",
    fieldLabel: "Name",
    placeholder: "Name",
    required: true,
  },
  {
    fieldType: "select",
    fieldName: "title",
    fieldLabel: "Title",
    placeholder: "- Select Title -",
    required: true,
    options: titleValues,
  },
  {
    fieldType: 'text',
    fieldName: 'address',
    fieldLabel: ADDRESS_FIELD_NAMES.address,
    placeholder: ADDRESS_FIELD_NAMES.address,
    required: true,
  },
  {
    fieldType: 'text',
    fieldName: 'address2',
    fieldLabel: ADDRESS_FIELD_NAMES.address2,
    placeholder: ADDRESS_FIELD_NAMES.address2,
  },
  {
    fieldType: 'text',
    fieldName: 'city',
    fieldLabel: ADDRESS_FIELD_NAMES.city,
    placeholder: ADDRESS_FIELD_NAMES.city,
    required: true,
  },
  {
    fieldType: 'text',
    fieldName: 'state',
    fieldLabel: ADDRESS_FIELD_NAMES.state,
    placeholder: ADDRESS_FIELD_NAMES.state,
    required: true,
  },
  {
    fieldType: 'text',
    fieldName: 'zip',
    fieldLabel: ADDRESS_FIELD_NAMES.zip,
    placeholder: ADDRESS_FIELD_NAMES.zip,
    required: true,
  },
];

const signatureTitleValues = [
  {
    value: "Assistant Secretary",
    label: "Assistant Secretary",
  },
  {
    value: "Assistant Treasurer",
    label: "Assistant Treasurer",
  },
  {
    value: "Chief Executive Officer",
    label: "Chief Executive Officer",
  },
  {
    value: "Chief Financial Officer",
    label: "Chief Financial Officer",
  },
  {
    value: "Chairman",
    label: "Chairman",
  },
  {
    value: "Director",
    label: "Director",
  },
  {
    value: "Power of Attorney",
    label: "Power of Attorney",
  },
  {
    value: "President",
    label: "President",
  },
  {
    value: "Secretary",
    label: "Secretary",
  },
  {
    value: "Treasurer",
    label: "Treasurer",
  },
  {
    value: "Vice President",
    label: "Vice President",
  },
];
